export interface PassengerIconState {
  icon: Phaser.GameObjects.Image;
  isStealing: boolean;
  progress: number;
}

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { Vehicle } from './../Vehicle';
import { VehicleIcons, VehicleSkins } from './../CharacterSpine';
import { Passenger } from '../level/Passenger';
import { Character } from '../Character';
/* END-USER-IMPORTS */

export default class TaxiUI extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 45, y ?? 45);

    // characterIcon
    const characterIcon = scene.add.image(0, -170, "common", "icon-taxi-tom.png");
    this.add(characterIcon);

    // bonusText
    const bonusText = scene.add.text(0, -217, "", {});
    bonusText.setOrigin(0.5, 0.5);
    bonusText.text = "+250";
    bonusText.setStyle({ "color": "#ffffffff", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "64px" });
    this.add(bonusText);

    this.characterIcon = characterIcon;
    this.bonusText = bonusText;

    /* START-USER-CTR-CODE */
    this.passengerIcons = new Map();
    this.bonusText.alpha = 0;
    this.bonusStartY = this.bonusText.y;
    this.isTweening = false;
    /* END-USER-CTR-CODE */
  }

  private characterIcon: Phaser.GameObjects.Image;
  private bonusText: Phaser.GameObjects.Text;
  public passengerListOffsetX: number = 60;
  public passengerIconOffsetX: number = 10;

  /* START-USER-CODE */
  protected vehicle: Vehicle | undefined;
  protected passengerIcons: Map<Passenger, PassengerIconState>;
  protected bonusStartY: number;
  protected isTweening: boolean;

  protected bestStealName: string = '';
  protected bestStealAmount: number = 0;

  protected iconScale:number = 0.3125;

  get passengerIconX(): number {
    return this.characterIcon.x - this.passengerListOffsetX;
  }

  get passengerIconY(): number {
    return this.characterIcon.y * this.scaleY;
  }

  // public getPassengerX(passenger: Passenger): number {
  //   if (this.passengerIcons.has(passenger)) {
  //     let state = this.passengerIcons.get(passenger);
  //     return state!.icon.x;
  //   }
  //   return 0;
  // }

  // public getPassengerY(passenger: Passenger): number {
  //   if (this.passengerIcons.has(passenger)) {
  //     let state = this.passengerIcons.get(passenger);
  //     return state!.icon.y;
  //   }
  //   return 0;
  // }

  public bindToVehicle(vehicle: Vehicle) {
    this.vehicle = vehicle;
    this.characterIcon.setFrame(Character.skinToCharacterIconLookup[vehicle.CurrentSkin]);
    this.characterIcon.setDepth(100);
  }

  public showScore(score: number) {
    this.scene.tweens.killTweensOf(this.bonusText);

    this.bonusText.alpha = 0;
    this.bonusText.text = `+${score}`;
    this.bonusText.y = this.bonusStartY;

    this.scene.add.tween({
      targets: this.bonusText,
      alpha: 1,
      y: '-= 25',
      duration: 650,
      ease: Phaser.Math.Easing.Circular.InOut
    });

    this.scene.add.tween({
      targets: this.bonusText,
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Circular.InOut,
      delay: 1000
    });
  }

  public addPassenger(passenger: Passenger, isStealing: boolean) {
    this.reorder(-this.passengerIconOffsetX);
    let passengerIcon = this.makeIcon(passenger.Icon);
    if (isStealing) passengerIcon.setAlpha(0.2);

    this.passengerIcons.set(passenger, {
      icon: passengerIcon,
      isStealing: isStealing,
      progress: 0
    });

    if (!isStealing) {
      passengerIcon.scale = 0;
      this.scene.add.tween({
        targets: [passengerIcon],
        scale: this.iconScale,
        duration: 1000,
        delay: 900,
        ease: Phaser.Math.Easing.Bounce.Out
      });
    }
  }

  public updatePassenger(passenger: Passenger, progress: number) {
    if (this.passengerIcons.has(passenger)) {
      let state = this.passengerIcons.get(passenger);
      if (!state) return;

      state.progress = progress;
      //state.icon.setAlpha(0.25 + 0.75 * progress);
      if (progress == 1) {
        state.icon.alpha = 1;
        state.icon.scale = 0.05;
        this.scene.add.tween({
          targets: [state.icon],
          scale: this.iconScale,
          duration: 500,
          ease: Phaser.Math.Easing.Bounce.Out
        });
        state.isStealing = false;
      }
      if (progress == 0) this.removePassenger(passenger);
    }
  }

  public iconDisplay(){

    let heightMod = 768 / window.innerHeight;
    let left = 1920 / 2 - (window.innerWidth * heightMod) / 2;
    left = Math.max(left, 0) + 50;
    let xpos = (this.x+this.passengerIconX) - this.scene.cameras.main.scrollX;

    if((xpos)<left){

      for (const [passenger, state] of this.passengerIcons) {
        state.icon.x = (left - xpos) + this.passengerIconX;
      }
    }
    else{
      for (const [passenger, state] of this.passengerIcons) {
        state.icon.x =this.passengerIconX;
      }
    }

  }

  public removePassenger(passenger: Passenger) {
    if (this.passengerIcons.has(passenger)) {
      let passengerState = this.passengerIcons.get(passenger);
      passengerState?.icon?.destroy();
      this.passengerIcons.delete(passenger);

      this.reorder(this.passengerIconOffsetX);
    }
  }

  public changePassenger(oldPassenger: Passenger, newPassenger: Passenger) {
    if (this.passengerIcons.has(oldPassenger)) {
      let state = this.passengerIcons.get(oldPassenger);
      if (!state) return;

      state.icon.setFrame(newPassenger.Icon);
      this.passengerIcons.delete(oldPassenger);
      this.passengerIcons.set(newPassenger, state);
    }
  }

  public updateBeingStolen(target: Vehicle, stealNum: number, passenger: Passenger) {
    if (this.passengerIcons.has(passenger)) {
      let state = this.passengerIcons.get(passenger);
      if (!state) return;

      if (this.isTweening) this.scene.tweens.killTweensOf(state.icon);

      let pct = stealNum / 100.0;

      if (pct < 0.9) {
        state.icon.scale = this.iconScale + pct * 0.3;
      } else {
        let pct2 = (pct - 0.9) * 10.0;
        state.icon.scale = this.iconScale + (0.3 - pct2 * 0.3);
      }

      //let dx = this.passengerIconX - target.passengerX;
      //let dy = this.passengerIconY - target.passengerY;
      let dx = this.vehicle!.x - target.x;
      let dy = this.vehicle!.y - target.y;
      let dist = Math.sqrt(dx * dx + dy * dy);

      let targetX = this.passengerIconX - pct * dx;
      let targetY = this.passengerIconY - pct * dy;
      let moveSpeed = 32;

      if (dist > moveSpeed) {
        let progress = moveSpeed / dist;
        state.icon.x = Phaser.Math.Interpolation.Linear([state.icon.x, targetX], progress);
        state.icon.y = Phaser.Math.Interpolation.Linear([state.icon.y, targetY], progress);
      } else {
        state.icon.x = this.passengerIconX - pct * dx;
        state.icon.y = this.passengerIconY - pct * dy;
      }

      // state.icon.x = this.passengerIconX - pct * dx;
      // state.icon.y = this.passengerIconY - pct * dy;

      // this.scene.children.bringToTop(state.icon);
    }
  }

  public stopBeingStolen(passenger: Passenger) {
    if (!this.passengerIcons.has(passenger)) return;

    let state = this.passengerIcons.get(passenger);
    if (!state) return;

    this.isTweening = true;

    this.scene.add.tween({
      targets: state.icon,
      x: this.passengerIconX,
      y: this.passengerIconY,
      ease: Phaser.Math.Easing.Cubic.Out,
      duration: 500,
      onComplete: () => {
        this.isTweening = false;
      }
    });
  }

  protected makeIcon(icon: string) {
    let passengerIcon = this.scene.make.image(
      { x: this.characterIcon.x - this.passengerListOffsetX, y: this.characterIcon.y, key: 'game-32', frame: icon },
      false
    );
    passengerIcon.setScale(this.iconScale);
    passengerIcon.setDepth(this.passengerIcons.size);
    this.add(passengerIcon);
    this.sort('depth');

    return passengerIcon;
  }

  protected reorder(direction: number) {
    for (const [passenger, state] of this.passengerIcons) {
      state.icon.x += direction;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
